import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Share Seal',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Share Seal',
        href: '/adm/opr/share-seal',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_seal_share',
    sortDesc: true,
    fields: [
      {
        key: 'code_share',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Tanggal',
      },
      {
        key: 'from_principle_name',
        label: 'From Principle',
      },
      {
        key: 'to_principle_name',
        label: 'To Principle',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      seal_number: '',
    },
    except_seal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeShareSeal(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchShareSeal(context, params = null) {
    let result = await ApiGetRequest(`opr/seal-share`, params);
    return !result.error ? result.data.object : [];
  },

  async getListShareSeal({ commit, state }) {
    commit('changeShareSeal', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      not_used: data.not_used ? 1 : 0,
      id_pay_booking: data.id_pay_booking ? data.id_pay_booking : 0,
      id_principle: data.id_principle ? data.id_principle : 0,
      except_seal: data.except_seal ? data.except_seal.join(',') : '',
    };

    let result = await ApiGetRequest(`opr/seal-share`, params);
    commit('changeShareSeal', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailShareSeal({ commit, state }, payload = null) {
    commit('changeShareSeal', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/seal-share/${payload.id}`);
    commit('changeShareSeal', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createShareSeal({ commit, state, dispatch }) {
    commit('changeShareSeal', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/seal-share`, state.data.form);
    commit('changeShareSeal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateShareSeal({ commit, state, dispatch }, payload = null) {
    commit('changeShareSeal', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/seal-share/${payload.id}`,
      state.data.form
    );

    commit('changeShareSeal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteShareSeal({ commit, dispatch }, payload = null) {
    commit('changeShareSeal', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/seal-share/${payload.id}`);
    commit('changeShareSeal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
